window.addEventListener('load', function() {
    // Nur für Pointer mit „feiner“ Maus (kein Touch)
    if (!window.matchMedia('(pointer: fine)').matches) return;

    // Alle Sektionen, die irgendwo ein data-depth-Element enthalten
    var $sections = $('section').filter(function() {
        return $(this).find('[data-depth]').length > 0;
    });

    if (!$sections.length) return;

    function setShift(el, dx, dy) {
        // Moderne Variante: translate-Eigenschaft, überschreibt NICHT die CSS-transform
        if ('translate' in el.style) {
            el.style.translate = dx + 'px ' + dy + 'px';
            return;
        }

        // Fallback: vorhandene transform auslesen und translate anhängen
        var cs = getComputedStyle(el);
        var base = cs.transform && cs.transform !== 'none' ? cs.transform : '';
        el.style.transform = (base ? base + ' ' : '') + 'translate3d(' + dx + 'px,' + dy + 'px,0)';
    }

    $sections.each(function(i, sectionEl) {
        var $section = $(sectionEl);
        var $targets = $section.find('[data-depth]');

        if (!$targets.length) return;

        var w = $section.outerWidth();
        var h = $section.outerHeight();

        var aimX = 0, aimY = 0;
        var lerpX = 0, lerpY = 0;
        var rafId = null;

        function onMove(e) {
            var off = $section.offset();
            var nx = (e.pageX - off.left) / w; // 0..1
            var ny = (e.pageY - off.top)  / h; // 0..1

            // -1 .. 1 normalisieren
            aimX = (nx - 0.5) * 2;
            aimY = (ny - 0.5) * 2;

            if (!rafId) rafId = requestAnimationFrame(tick);
        }

        function tick() {
            // weiches Nachziehen
            lerpX += (aimX - lerpX) * 0.12;
            lerpY += (aimY - lerpY) * 0.12;

            $targets.each(function() {
                var depth = parseFloat(this.getAttribute('data-depth') || '10'); // px max shift
                var dx = lerpX * depth;
                var dy = lerpY * depth;
                setShift(this, dx, dy);
            });

            if (Math.abs(aimX - lerpX) > 0.001 || Math.abs(aimY - lerpY) > 0.001) {
                rafId = requestAnimationFrame(tick);
            } else {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        }

        // Events für diese Section
        $section.on('mousemove.parallax', onMove);

        $section.on('mouseleave.parallax', function() {
            // Zur Mitte zurückfahren
            aimX = 0;
            aimY = 0;
            if (!rafId) rafId = requestAnimationFrame(tick);
        });

        // Resize für diese Section
        $(window).on('resize.parallax' + i, function() {
            w = $section.outerWidth();
            h = $section.outerHeight();
        });
    });
});
